export type AccountInfo = {
  id: string;
  address: string;
  name: string;
};

export enum ACCOUNT_PROVIDER_ID {
  PLAY_ACCOUNT_PROVIDER = 'playAccountProvider',
  REOWN_EVM_ACCOUNT_PROVIDER = 'reownEvmAccountProvider',
}

export interface Account {
  id: string;
  address: string;
  name: string;
  isPlayAccount: boolean;
  providerId: ACCOUNT_PROVIDER_ID;
}

export interface ConnectedAccount {
  account: Account;
  providerId: ACCOUNT_PROVIDER_ID;
}
